module.exports = __webpack_public_path__ + "img/service-and-shop-filter-infiniti.a9a52f9d.jpg";